unit unit_ListeAnsprechpartner;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  WEBLib.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls, XData.Web.Client,
  WEBLib.WebCtrls, strutils;

type
  TListeAnsprechpartner = class(TForm)
    xdsListe: TXDataWebDataSet;
    Container3: THTMLContainer;
    Container2: THTMLContainer;
    Container1: THTMLContainer;
    xdsListeAnsprechpartner: TStringField;
    xdsListeAbteilung: TStringField;
    xdsListeNachname: TStringField;
    xdsListeVorname: TStringField;
    xdsListeTelefonNummer: TStringField;
    xdsListeTelefonDurchwahl: TStringField;
    xdsListeTelefaxNummer: TStringField;
    xdsListeMobilTelefon: TStringField;
    xdsListeEMail: TStringField;
    xdsListeInternet: TStringField;
    xdsListeGeburtstag: TDateTimeField;
    xdsListeBemerkung: TStringField;
    xdsListeKeinNewsletter: TBooleanField;
    xdsListeAdresseBild: TStringField;
    xdsListeBriefanrede1: TStringField;
    xdsListeTitel: TStringField;
    xdsListeAPID: TStringField;
    xdsListeAnrede: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsListeAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    KundennummerID:string;
    NachnameID:string;
    buttonzurueck:TButton;
    EinzelCard:THTMLDiv;
    procedure buttonzurueckclick(Sender:TObject);
    procedure EinzelCardclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  ListeAnsprechpartner: TListeAnsprechpartner;

implementation
  uses unit1, unit2, unit_Kontaktsuche, unit_EinzelAnsprechpartner;
{$R *.dfm}

procedure TListeAnsprechpartner.buttonzurueckclick(Sender:TObject);
begin
  xdsListe.Close;
  self.close;
end;

procedure TListeAnsprechpartner.EinzelCardclick(Sender:TObject);
var
  EinzelEinzelAnsprechpartner:TEinzelAnsprechpartner;
  MyMerkerAP:string;
begin
  myMerkerAP:=(sender as THTMLDiv).ElementID;
  Container3.HTML.text:='';
  EinzelAnsprechpartner := TEinzelAnsprechpartner.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TEinzelAnsprechpartner).APID:=myMerkerAP;
    end
    );

  EinzelAnsprechpartner.ShowModal(procedure(AValue: TModalResult)
    begin
      xdsListe.close;
      xdsListe.Load;
    end
    );
end;

procedure TListeAnsprechpartner.WebFormShow(Sender: TObject);
begin
  xdsListe.QueryString:='$filter=Kundennummer eq '+quotedstr(KundennummerID)+'&$orderby=Ansprechpartner';
  xdsListe.Load;
end;

procedure TListeAnsprechpartner.xdsListeAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Ansprechpartner ('+ KundennummerID+ ') '+NachnameID+'</h5></nav>';
  Container2.HTML.Text:='';
  myelement:=container2.ElementHandle;
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info m-1 text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  while not xdsListe.eof do
  begin
    Einzelkarte:='<div class="card-header"><h5>'+xdsListeAnsprechpartner.asstring+'</h5></div>';
    Einzelkarte:=Einzelkarte+'<div class="card-body ">'+xdsListeNachname.AsString+' ,'+xdsListeVorname.AsString;
    Einzelkarte:=Einzelkarte+'<br>'+xdsListeAbteilung.Asstring+'<br>';
    Einzelkarte:=Einzelkarte+'<br>'+xdsListeTelefonNummer.Asstring+'<br>';
    Einzelkarte:=Einzelkarte+'<br>'+xdsListeMobilTelefon.Asstring+'<br>';
    Einzelkarte:=Einzelkarte+'<br>'+xdsListeEMail.Asstring+'<br>';
    Einzelkarte:=Einzelkarte+'<br>'+xdsListeInternet.Asstring+'<br>';
    if xdsListeBemerkung.AsString<>'' then Einzelkarte:=Einzelkarte+'Bemerkung: '+xdsListeBemerkung.asstring+'<br>';
    Einzelkarte:=Einzelkarte+'</div>';
    myelement:=Container3.ElementHandle;
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:=xdsListeAPID.asstring;
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.Width:=350;
    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card m-1 border-info';
    EinzelCard.OnClick:=@EinzelCardClick;
    EinzelCard.ParentElement:=myelement;
    xdsListe.Next;
  end;
end;

procedure TListeAnsprechpartner.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Container3 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  xdsListe := TXDataWebDataSet.Create(Self);
  xdsListeAnsprechpartner := TStringField.Create(Self);
  xdsListeAbteilung := TStringField.Create(Self);
  xdsListeNachname := TStringField.Create(Self);
  xdsListeVorname := TStringField.Create(Self);
  xdsListeTelefonNummer := TStringField.Create(Self);
  xdsListeTelefonDurchwahl := TStringField.Create(Self);
  xdsListeTelefaxNummer := TStringField.Create(Self);
  xdsListeMobilTelefon := TStringField.Create(Self);
  xdsListeEMail := TStringField.Create(Self);
  xdsListeInternet := TStringField.Create(Self);
  xdsListeGeburtstag := TDateTimeField.Create(Self);
  xdsListeBemerkung := TStringField.Create(Self);
  xdsListeKeinNewsletter := TBooleanField.Create(Self);
  xdsListeAdresseBild := TStringField.Create(Self);
  xdsListeBriefanrede1 := TStringField.Create(Self);
  xdsListeTitel := TStringField.Create(Self);
  xdsListeAPID := TStringField.Create(Self);
  xdsListeAnrede := TStringField.Create(Self);

  Container3.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  xdsListe.BeforeLoadDFMValues;
  xdsListeAnsprechpartner.BeforeLoadDFMValues;
  xdsListeAbteilung.BeforeLoadDFMValues;
  xdsListeNachname.BeforeLoadDFMValues;
  xdsListeVorname.BeforeLoadDFMValues;
  xdsListeTelefonNummer.BeforeLoadDFMValues;
  xdsListeTelefonDurchwahl.BeforeLoadDFMValues;
  xdsListeTelefaxNummer.BeforeLoadDFMValues;
  xdsListeMobilTelefon.BeforeLoadDFMValues;
  xdsListeEMail.BeforeLoadDFMValues;
  xdsListeInternet.BeforeLoadDFMValues;
  xdsListeGeburtstag.BeforeLoadDFMValues;
  xdsListeBemerkung.BeforeLoadDFMValues;
  xdsListeKeinNewsletter.BeforeLoadDFMValues;
  xdsListeAdresseBild.BeforeLoadDFMValues;
  xdsListeBriefanrede1.BeforeLoadDFMValues;
  xdsListeTitel.BeforeLoadDFMValues;
  xdsListeAPID.BeforeLoadDFMValues;
  xdsListeAnrede.BeforeLoadDFMValues;
  try
    Name := 'ListeAnsprechpartner';
    Width := 180;
    Height := 319;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.HeightPercent := 100.000000000000000000;
    Container3.WidthPercent := 100.000000000000000000;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.HeightPercent := 100.000000000000000000;
    Container2.WidthPercent := 100.000000000000000000;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.HeightPercent := 100.000000000000000000;
    Container1.WidthPercent := 100.000000000000000000;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    xdsListe.SetParentComponent(Self);
    xdsListe.Name := 'xdsListe';
    xdsListe.AfterOpen := xdsListeAfterOpen;
    xdsListe.EntitySetName := 'Ansprechpartner';
    xdsListe.Connection := DM2.XDataWebConnection1;
    xdsListe.SubpropsDepth := 1;
    xdsListe.QueryTop := 100;
    xdsListe.Left := 20;
    xdsListe.Top := 142;
    xdsListeAnsprechpartner.SetParentComponent(xdsListe);
    xdsListeAnsprechpartner.Name := 'xdsListeAnsprechpartner';
    xdsListeAnsprechpartner.FieldName := 'Ansprechpartner';
    xdsListeAnsprechpartner.Size := 50;
    xdsListeAbteilung.SetParentComponent(xdsListe);
    xdsListeAbteilung.Name := 'xdsListeAbteilung';
    xdsListeAbteilung.FieldName := 'Abteilung';
    xdsListeAbteilung.Size := 50;
    xdsListeNachname.SetParentComponent(xdsListe);
    xdsListeNachname.Name := 'xdsListeNachname';
    xdsListeNachname.FieldName := 'Nachname';
    xdsListeNachname.Size := 40;
    xdsListeVorname.SetParentComponent(xdsListe);
    xdsListeVorname.Name := 'xdsListeVorname';
    xdsListeVorname.FieldName := 'Vorname';
    xdsListeVorname.Size := 40;
    xdsListeTelefonNummer.SetParentComponent(xdsListe);
    xdsListeTelefonNummer.Name := 'xdsListeTelefonNummer';
    xdsListeTelefonNummer.FieldName := 'TelefonNummer';
    xdsListeTelefonNummer.Size := 25;
    xdsListeTelefonDurchwahl.SetParentComponent(xdsListe);
    xdsListeTelefonDurchwahl.Name := 'xdsListeTelefonDurchwahl';
    xdsListeTelefonDurchwahl.FieldName := 'TelefonDurchwahl';
    xdsListeTelefonDurchwahl.Size := 10;
    xdsListeTelefaxNummer.SetParentComponent(xdsListe);
    xdsListeTelefaxNummer.Name := 'xdsListeTelefaxNummer';
    xdsListeTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsListeTelefaxNummer.Size := 25;
    xdsListeMobilTelefon.SetParentComponent(xdsListe);
    xdsListeMobilTelefon.Name := 'xdsListeMobilTelefon';
    xdsListeMobilTelefon.FieldName := 'MobilTelefon';
    xdsListeMobilTelefon.Size := 25;
    xdsListeEMail.SetParentComponent(xdsListe);
    xdsListeEMail.Name := 'xdsListeEMail';
    xdsListeEMail.FieldName := 'EMail';
    xdsListeEMail.Size := 50;
    xdsListeInternet.SetParentComponent(xdsListe);
    xdsListeInternet.Name := 'xdsListeInternet';
    xdsListeInternet.FieldName := 'Internet';
    xdsListeInternet.Size := 50;
    xdsListeGeburtstag.SetParentComponent(xdsListe);
    xdsListeGeburtstag.Name := 'xdsListeGeburtstag';
    xdsListeGeburtstag.FieldName := 'Geburtstag';
    xdsListeBemerkung.SetParentComponent(xdsListe);
    xdsListeBemerkung.Name := 'xdsListeBemerkung';
    xdsListeBemerkung.FieldName := 'Bemerkung';
    xdsListeBemerkung.Size := 255;
    xdsListeKeinNewsletter.SetParentComponent(xdsListe);
    xdsListeKeinNewsletter.Name := 'xdsListeKeinNewsletter';
    xdsListeKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsListeAdresseBild.SetParentComponent(xdsListe);
    xdsListeAdresseBild.Name := 'xdsListeAdresseBild';
    xdsListeAdresseBild.FieldName := 'AdresseBild';
    xdsListeAdresseBild.Size := 255;
    xdsListeBriefanrede1.SetParentComponent(xdsListe);
    xdsListeBriefanrede1.Name := 'xdsListeBriefanrede1';
    xdsListeBriefanrede1.FieldName := 'Briefanrede1';
    xdsListeBriefanrede1.Size := 255;
    xdsListeTitel.SetParentComponent(xdsListe);
    xdsListeTitel.Name := 'xdsListeTitel';
    xdsListeTitel.FieldName := 'Titel';
    xdsListeAPID.SetParentComponent(xdsListe);
    xdsListeAPID.Name := 'xdsListeAPID';
    xdsListeAPID.FieldName := 'APID';
    xdsListeAPID.Required := True;
    xdsListeAPID.Size := 38;
    xdsListeAnrede.SetParentComponent(xdsListe);
    xdsListeAnrede.Name := 'xdsListeAnrede';
    xdsListeAnrede.FieldName := 'Anrede';
    xdsListeAnrede.Size := 15;
  finally
    Container3.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    xdsListe.AfterLoadDFMValues;
    xdsListeAnsprechpartner.AfterLoadDFMValues;
    xdsListeAbteilung.AfterLoadDFMValues;
    xdsListeNachname.AfterLoadDFMValues;
    xdsListeVorname.AfterLoadDFMValues;
    xdsListeTelefonNummer.AfterLoadDFMValues;
    xdsListeTelefonDurchwahl.AfterLoadDFMValues;
    xdsListeTelefaxNummer.AfterLoadDFMValues;
    xdsListeMobilTelefon.AfterLoadDFMValues;
    xdsListeEMail.AfterLoadDFMValues;
    xdsListeInternet.AfterLoadDFMValues;
    xdsListeGeburtstag.AfterLoadDFMValues;
    xdsListeBemerkung.AfterLoadDFMValues;
    xdsListeKeinNewsletter.AfterLoadDFMValues;
    xdsListeAdresseBild.AfterLoadDFMValues;
    xdsListeBriefanrede1.AfterLoadDFMValues;
    xdsListeTitel.AfterLoadDFMValues;
    xdsListeAPID.AfterLoadDFMValues;
    xdsListeAnrede.AfterLoadDFMValues;
  end;
end;

end.